const invisibleCharCodes = [8206];
const invisibleCharacters = invisibleCharCodes.map(c => String.fromCharCode(c));

export function trim(str: string) {
    let trimmed = str.trim();
    while (trimmed.length > 0 && invisibleCharacters.includes(trimmed[0])) {
        trimmed = trimmed.substring(1);
    }
    while (
        trimmed.length > 0 &&
        invisibleCharacters.includes(trimmed[trimmed.length - 1])
    ) {
        trimmed = trimmed.slice(0, -1);
    }
    return trimmed;
}

